const Secured = ({ className }: { className?: string }) => {
  return (
    <svg
      width="25"
      height="35"
      viewBox="0 0 25 35"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.4549 0C7.28021 0 3.11374 4.46032 3.11374 10V11.6667C1.40118 11.6667 0 13.1667 0 15V31.6667C0 33.5 1.40118 35 3.11374 35H21.7962C23.5087 35 24.9099 33.5 24.9099 31.6667V15C24.9099 13.1667 23.5087 11.6667 21.7962 11.6667V10C21.7962 4.46032 17.6297 0 12.4549 0ZM12.4549 3.33333C15.9987 3.33333 18.6824 6.20635 18.6824 10V11.6667H6.22747V10C6.22747 6.20635 8.91122 3.33333 12.4549 3.33333ZM12.4549 20C14.1675 20 15.5687 21.5 15.5687 23.3333C15.5687 25.1667 14.1675 26.6667 12.4549 26.6667C10.7424 26.6667 9.34121 25.1667 9.34121 23.3333C9.34121 21.5 10.7424 20 12.4549 20Z"
        fill="#FB2576"
      />
    </svg>
  );
};

export default Secured;
